module.exports = __webpack_public_path__ + "img/TruckRoute.1b59187c.svg";